import React from 'react';
import TextField from '@material-ui/core/TextField';
import ButtonBase from '../../../components/Buttons/ButtonBase';
import {auths, firestore } from '../../../configs/environments/firebase/firebaseApp';

const FormPhoneNumberClient = props => {
    const {
        values,
        handleChange,
        handleBlur,
        handleSubmit,
        touched,
        errors,
        isValid,
    } = props;

    return (
        <form onSubmit={handleSubmit}>
            <TextField
                id="phoneNumber"
                name="phoneNumber"
                type="text"
                variant="outlined"
                label="Número telefónico"
                placeholder="10 dígitos: 5511223344"
                value={values.phoneNumber}
                onChange={handleChange}
                onBlur={handleBlur}
                helperText={
                touched.phoneNumber && errors.phoneNumber && errors.phoneNumber
                }
                error={touched.phoneNumber && errors.phoneNumber ? true : false}
            />
            <br />
            <ButtonBase
                type="submit"
                variant="primary"
                isValid={isValid}
            >
                Guardar Cambios
            </ButtonBase>
        </form>
    );
};

export default FormPhoneNumberClient;